import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import "./addPlayerModal.scss";
import SelectPlayer from "./SelectPlayer";
import useArrayState from '../hooks/useArrayState';

const PlayersModal = ({players, isShowing, hide, playersSelected}) => {   
    const { state, setArray } = useArrayState([]);

    if (!isShowing) return null;

    const selectPlayers = (e) => {
        e.preventDefault();
        console.log(state);
        hide();
        playersSelected(state);
        console.log("Finish selecting");
    }

    return ReactDOM.createPortal(
        <React.Fragment>
        <div className="modal-overlay"/>
        <div className="modal-wrapper" aria-modal aria-hidden tabIndex={-1} role="dialog">
          <div className="modal">
            <div className="modal-header">
              <button type="button" className="modal-close-button" data-dismiss="modal" aria-label="Close" onClick={hide}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div>
                <h3>Select Players</h3>

                <div>
                {/* {
                        players.map(player => (
                          <button key={player.id} onClick={() => setArray(player)} className={`player-button ${state.includes(player) ? "active" : ""}`} isSelected={state.includes(player)}>
                              {player.name}
                          </button>
                      ))  
                      } */}
                </div>
                <form onSubmit={selectPlayers}>
                  <ul>
                      {
                        players.map(player => (
                          <li key={player.id}>
                              <SelectPlayer player={player} onSelected={setArray} isSelected={state.includes(player)}></SelectPlayer>
                          </li>
                      ))  
                      }
                  </ul>
                </form>
                
                <button onClick={selectPlayers}>Done</button>
            </div>
          </div>
        </div>
      </React.Fragment>, document.body
    )
};

export default PlayersModal;